import { formatDailyRecapShortDate } from "./dailyRecapDisplay";

export const DAILY_CLOSURE_REPORT_TYPE = "daily_closure";

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export interface DailyRecapReportContext {
  requested: boolean;
  date: string | null;
  warehouseId: number | null;
  autoPreview: boolean;
}

const normalizeDateOnly = (value: unknown): string | null => {
  const candidate = typeof value === "string" ? value.trim() : "";
  if (!DATE_ONLY_PATTERN.test(candidate)) return null;

  const parsed = new Date(`${candidate}T12:00:00Z`);
  if (
    Number.isNaN(parsed.getTime()) ||
    parsed.toISOString().slice(0, 10) !== candidate
  ) {
    return null;
  }

  return candidate;
};

const normalizePositiveInteger = (value: unknown): number | null => {
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 ? number : null;
};

export function buildDailyRecapReportUrl(
  data: Record<string, unknown> = {},
  fallbackWarehouseId: unknown = null
): string {
  const date = normalizeDateOnly(data.recap_date);
  const warehouseId =
    normalizePositiveInteger(fallbackWarehouseId) ||
    normalizePositiveInteger(data.warehouse_id);
  const params = new URLSearchParams();

  params.set("type", DAILY_CLOSURE_REPORT_TYPE);
  if (date) params.set("date", date);
  if (warehouseId) params.set("warehouseId", String(warehouseId));
  if (date) params.set("preview", "1");

  return `/rapport?${params.toString()}`;
}

export function getDailyRecapReportAction(
  data: Record<string, unknown> = {},
  fallbackWarehouseId: unknown = null
) {
  const date = normalizeDateOnly(data.recap_date);

  return {
    url: buildDailyRecapReportUrl(data, fallbackWarehouseId),
    label: date
      ? `Voir le détail du ${formatDailyRecapShortDate(date)}`
      : "Voir le détail de la clôture",
  };
}

export function parseDailyRecapReportContext(
  search: string
): DailyRecapReportContext {
  const params = new URLSearchParams(search || "");
  const requested = params.get("type") === DAILY_CLOSURE_REPORT_TYPE;
  const date = requested ? normalizeDateOnly(params.get("date")) : null;
  const warehouseId = requested
    ? normalizePositiveInteger(params.get("warehouseId"))
    : null;

  return {
    requested,
    date,
    warehouseId,
    autoPreview: requested && Boolean(date) && params.get("preview") === "1",
  };
}
